import { z } from "zod";
export const dmaChemicalElementDtoSchema = z.object({
    id: z.number(),
    symbol: z.string(),
    name: z.string(),
    molarMass: z.number(),
});
